<template>
  <div>
    <div class="search-table">
      <el-date-picker
          style="width: 115px"
          class="custom-date-picker"
          :clearable="false"
          v-model="monthAndYear"
          type="month"
          @change="handelUpdateDate"
          placeholder="Chọn tháng"
          value-format="M-yyyy"
          format="MM-yyyy"
          :time-arrow-control="false"
      >
      </el-date-picker>
      <!-- chọn trạng thái -->
      <el-select
          @change="handleChangeKidStatus"
          style="width: 120px"
          class=""
          v-model="dataSearch.kidStatus"
          placeholder="Trạng thái"
      >
        <el-option
            v-for="(item,index) in kidStatusListExcel"
            :key="index"
            :value="item.key"
            :label="item.value"
        ></el-option>
      </el-select>

      <!-- chọn khối -->
      <el-select
          @change="handleChangeKidGrade"
          class=" input-grade"
          style="width: 160px"
          v-model="dataSearch.idGrade"
          placeholder="Chọn khối"
      >
        <el-option
            v-for="(item,index) in gradeList"
            :key="index"
            :value="item.id"
            :label="item.gradeName"
        ></el-option>
      </el-select>

      <!-- chọn lớp -->
      <el-select
          style="width: 160px"
          v-model="dataSearch.idClass"
          @change="handleChangeKidClass"
          placeholder="Chọn lớp"
      >
        <el-option
            v-for="item in classList"
            :key="item.id"
            :value="item.id"
            :label="item.className"
        >
        </el-option>
      </el-select>
      <el-input
          @clear="handleClearKidName"
          clearable
          style="width: 240px"
          placeholder="Nhập tên, biệt danh"
          v-model="kidName"
          @keyup.enter.native="handleChangeKidName"
      >
        <template #append>
          <el-button
              icon="el-icon-search"
              @click="handleSearchResultByName"
          ></el-button>
        </template>
      </el-input>
      <el-select
          @change="handleChangeCollectionTurn"
          style="width: 100px"
          class=""
          v-model="dataSearch.collectionTurn"
          placeholder="Đợt thu"
      >
        <el-option
            v-for="item in collectionTurn"
            :key="item"
            :value="item"
            :label="`Đợt ${item}`"
        ></el-option>
      </el-select>
    </div>
    <div>
      <el-table
          element-loading-spinner="el-icon-loading"
          :empty-text="textTable"
          :data="responseFilterList"
          :element-loading-text="$tableLoading"
          element-loading-background="rgba(255,255,255, 0)"
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChange"
          :max-height="$tableMaxHeight"
          :summary-method="getSummaries"
          show-summary
          border
      >
        <el-table-column
            type="index"
            fixed="left"
            label="STT"
            width="50"
            align="center"
        ></el-table-column>

        <el-table-column width="150" fixed="left" label="Họ tên">
          <template v-slot:default="scope">
            <el-tooltip placement="top">
              <div slot="content">Mã học sinh: {{ scope.row.kidCode }}<br>Bố/Mẹ: {{ scope.row.fatherPhone }} -
                {{ scope.row.motherPhone }}
              </div>
              <span>{{ scope.row.fullName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column width="90" label="Biệt danh" align="center">
          <template v-slot:default="scope">
            <span>{{ scope.row.nickName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" width="110" label="Trạng thái">
          <template v-slot:default="scope">
            <div :class="getStatusColor(scope.row.status)">
              {{ getStatusValue(scope.row.status) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            align="right"
            min-width="120"
            label="Thiếu/Thừa tháng trước"
            prop="beforeMoney"
        >
          <template v-slot:default="scope">
            {{ scope.row.beforeMoney | formatCurrency }}
          </template>
        </el-table-column>

        <el-table-column align="right" min-width="120" label="Phải thu tháng này" prop="sumMoney">
          <template v-slot:default="scope">
            {{ scope.row.sumMoney | formatCurrency }}
          </template>
        </el-table-column>

        <el-table-column align="right" min-width="120" label="Đã thu" prop="collectedMoney">
          <template v-slot:default="scope">
            <el-button
                v-if="getStatusValue(scope.row.status) !=='Chưa có hóa đơn'"
                class="click-in-row"
                type="text"
                @click="collectedMoneyMethod(scope.row)">
              <span v-if="scope.row.collectedMoney">{{ scope.row.collectedMoney | formatCurrency }}</span>
              <span v-else><b>-</b></span>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="right" min-width="120" label="Tiền mặt" prop="cashMoney">
          <template v-slot:default="scope">
            {{ scope.row.cashMoney | formatCurrency }}
          </template>
        </el-table-column>

        <el-table-column align="right" min-width="120" label="Chuyển khoản" prop="transferMoney">
          <template v-slot:default="scope">
            {{ scope.row.transferMoney | formatCurrency }}
          </template>
        </el-table-column>
        <el-table-column align="right" min-width="120" label="Thiếu / Thừa còn lại" prop="afterMoney">
          <template v-slot:default="scope">
            {{ scope.row.afterMoney | formatCurrency }}
          </template>
        </el-table-column>
        <el-table-column
            v-for="(item, index) in feeItems"
            :key="index"
            align="right"
            width="115"
            :label="item.label"
            :prop="item.prop"
        >
          <template #header="scope">
            <el-tooltip :content="scope.column.label" placement="top">
              <span>{{ scope.column.label }}</span>
            </el-tooltip>
          </template>

          <template v-slot:default="scope">
            <el-button
                v-if="getStatusValue(scope.row.status) !== 'Chưa có hóa đơn'"
                class="click-in-row"
                type="text"
                @click="getDetailKT(scope.row, scope.column.label, scope.row.status)"
            >
      <span v-if="scope.row[item.prop]">
        {{ scope.row[item.prop] | formatCurrency }}
      </span>
              <span v-else>-</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-row style="margin-top: 15px ">
      <el-col :span="22" style=" display: inline-flex;justify-content: right ">
        <el-pagination
            style=" margin-right: 35.2rem;margin-left: auto"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPagePagination"
            :page-sizes="listSizeLimit"
            :page-size="sizeLimit"
            layout=" prev, pager,sizes, next"
            :total="total"
        >
        </el-pagination>
      </el-col>
      <el-col :span="2">
        <div style="float: right; margin: 15px 0">
          <el-dropdown @command="handleCommand">
            <el-button class="button-bottom" type="success">
              Tác vụ
              <i class="el-icon-caret-bottom"/>
            </el-button>
            <el-dropdown-menu class="el-dropdown-menu-container">
              <el-dropdown-item command="initializeData">Khởi tạo đợt thu</el-dropdown-item>
              <el-dropdown-item command="initializeOrderKidsExcel">Khởi tạo hóa đơn</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
    <div>
      <ImportDataRevenueDialog
          :isOpenImportData="isOpenImportData"
          :listIdRevenueManagement="listIdRevenueManagement"
          :listIdKids="listIdKids"
          :dataSearch="dataSearch"
          :type="type"
          @close="closeImportDataRevenueDialog"
      />
      <DetailKTRevenueDialog
          :type="type"
          :idOrder="idOrder"
          :isOpenDetailKT="detailKT"
          @close="closeDetailKTRevenueDialog"
          ref="DetailKTRevenueDialog"
      />
      <CollectedMoneyRevenueDialog
          :isOpenCollectedMoney="showCollectedMoney"
          @closeCollectedMoney="closeCollectedMoneyRevenueDialog"
          ref="CollectedMoneyRevenueDialog"
      />
      <InitializeOrderKidsExcelDialog
          :listKidCode="listKidCode"
          :listIdOrder="listIdOrder"
          :dataSearch="dataSearch"
          :type="type"
          :isOpenInitializeOrderKidsExcelDialog="isOpenInitializeOrderKidsExcelDialog"
          @close="closeInitializeOrderKidsExcelDialog"
      />
    </div>
  </div>
</template>
<script>
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import moment from "moment";
import GradeService from "@/services/GradeService";
import checkPermission from "@/utils/permission";
import {kidStatusListExcel} from "@/constant/listCommon";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import tableValidateMixin from "@/global/mixin/tableValidate.mixin";
import countColumnActionMixin from "@/global/mixin/countColumnAction.mixin";
import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import ImportDataRevenueDialog from "@/components/FinanceVer2/TuitionManagement/dialog/ImportDataRevenueDialog.vue";
import DetailKTRevenueDialog from "@/components/FinanceVer2/TuitionManagement/dialog/DetailKTRevenueDialog.vue";
import CollectedMoneyRevenueDialog
  from "@/components/FinanceVer2/TuitionManagement/dialog/CollectedMoneyRevenueDialog.vue";
import InitializeOrderKidsExcelDialog
  from "@/components/FinanceVer2/TuitionManagement/dialog/InitializeOrderKidsExcelDialog.vue";

export default {
  name: "InitializeClassTuition",
  components: {
    InitializeOrderKidsExcelDialog,
    CollectedMoneyRevenueDialog, DetailKTRevenueDialog, ImportDataRevenueDialog},
  watch: {
    monthAndYear: {
      handler(val) {
        this.dataSearch.month = val.split('-')[0]
        this.dataSearch.createdYear = val.split('-')[1]

      }
    },
  },
  computed: {
    feeItems() {
      const items = [];
      for (let i = 1; i <= 20; i++) {
        const name = this.listKT[`nameKt${i}`];
        // items.push({
        //   label: name,
        //   prop: `moneyKt${i}`
        // });
        if (name && name !== `Khoản thu ${i}`) {
          items.push({
            label: name,
            prop: `moneyKt${i}`
          });
        }
      }
      return items;
    }
  },
  created() {
    this.fetchDataTable();
    this.dataSearch.monthAndYear = this.monthAndYear
  },
  mixins: [tableValidateMixin, countColumnActionMixin],
  data() {
    return {
      isUpdateCollectionTurn: true,
      monthAndYear: moment().format('M-yyyy'),
      // watcher
      dataInitialized: false, // sử dụng để ngăn watcher call api khởi tạo data
      // phân trang
      currentPagePagination: 1,
      // tên học sinh
      kidName: "",
      status: [],
      kidStatusListExcel,
      gradeList: [],
      classList: [],
      statusOrderList: [],
      flag: false,
      sizeLimit: 30,
      listSizeLimit: [30, 40, 50, 100],
      collectionTurn: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      dataSearch: {
        monthAndYear: "",
        collectionTurn: 1, // đợt thu
        month: moment().format('M'),
        kidStatus: "STUDYING",
        idGrade: "",
        idClass: "",
        idGroup: 0,
        name: "", // tên học sinh
        page: 1,
        limit: 30,
        statusList: [],
        createdYear: moment().format("YYYY"),
      },

      responseFilterList: [],
      textTable: this.$tableEmpty,
      listKT: {
        nameKt1: "Khoản thu 1",
        nameKt2: "Khoản thu 2",
        nameKt3: "Khoản thu 3",
        nameKt4: "Khoản thu 4",
        nameKt5: "Khoản thu 5",
        nameKt6: "Khoản thu 6",
        nameKt7: "Khoản thu 7",
        nameKt8: "Khoản thu 8",
        nameKt9: "Khoản thu 9",
        nameKt10: "Khoản thu 10",
        nameKt11: "Khoản thu 11",
        nameKt12: "Khoản thu 12",
        nameKt13: "Khoản thu 13",
        nameKt14: "Khoản thu 14",
        nameKt15: "Khoản thu 15",
        nameKt16: "Khoản thu 16",
        nameKt17: "Khoản thu 17",
        nameKt18: "Khoản thu 18",
        nameKt19: "Khoản thu 19",
        nameKt20: "Khoản thu 20"
      },
      total: 0,
      listIdRevenueManagement: [],
      listIdKids: [],
      isOpenImportData: false,
      detailKT: false,
      idOrder: 0,
      showCollectedMoney: false,
      isOpenInitializeOrderKidsExcelDialog: false,
      listIdOrder: [],
      listKidCode: [],
      type: "CLASS",
    };
  },
  // xoá dữ liệu khi back lại, f5 trang

  methods: {
    checkPermission,
    // lấy lượt thu theo ngày
    handelUpdateDate() {
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.isUpdateCollectionTurn = true
      this.dataSearch.monthAndYear = this.monthAndYear
      this.getFilterAll()
    },
    // xử lý đổi trạng thái HS
    handleChangeKidStatus() {
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.getFilterAll()
    },
    // bắt sự kiện tìm theo tên qua enter
    handleChangeKidName() {
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.dataSearch.name = this.kidName;
      this.getFilterAll()
    },

    // Trả ra kết quả tìm kiếm theo tên khi bấm vào icon tìm kiếm
    handleSearchResultByName() {
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.dataSearch.name = this.kidName;
      this.getFilterAll()
    },
    // tìm kiếm khi xóa tên học sinh
    handleClearKidName() {
      this.dataSearch.page = 1;
      this.currentPagePagination = 1;
      this.dataSearch.name = this.kidName;
      this.getFilterAll()
    },
    handleChangeCollectionTurn() {
      this.dataSearch.page = 1;
      this.currentPagePagination = 1;
      this.getFilterAll()
    },
    /**
     Xử lý phân trang
     */
    handleSizeChange(value) {
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.sizeLimit = value;
      this.dataSearch.limit = value;
      this.getFilterAll()
    },
    handleCurrentChange(value) {
      this.currentPagePagination = value;
      this.dataSearch.page = value;
      this.getFilterAll()
    },
    // lấy danh sách trươc khi lấy ra table
    fetchDataTable() {
      this.getAllGrade(); // lấy danh sách lớp
    },

    /**
     * tìm tất cả các khối trong một trường
     */
    getAllGrade() {
      GradeService.getGradeInPrinciple()
          .then((resp) => {
            this.gradeList = resp.data.data;
            if (this.gradeList.length > 0) {
              this.dataSearch.idGrade = this.gradeList[0].id; // cái này sẽ chạy api lấy getClassOfGrade
              this.getClassOfGrade();
            }
          })
          .catch((err) => {
            console.log(err);
            NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!")
          });
    },

    /**
     * thay đổi khối
     */
    handleChangeKidGrade() {
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.isUpdateCollectionTurn = true; // cho phép gọi update đợt thu mới nhất
      this.getClassOfGrade();
    },
    getClassOfGrade() {
      financeKidsV2Service
          .getClassInGrade(this.dataSearch.idGrade)
          .then((resp) => {
            resp.data && resp.data.data ? this.classList = resp.data.data : this.classList = []
            this.classList.length > 0 ? this.dataSearch.idClass = this.classList[0].id : this.dataSearch.idClass = '' // data để hiển thị lên bảng
            this.getFilterAll()
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!")
            console.log(err);
          });
    },
    /**
     * Thay đổi lớp
     */
    handleChangeKidClass() {
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.isUpdateCollectionTurn = true
      this.getFilterAll()
    },

    async handleCommand(command) {
      switch (command) {
        case "initializeData": {
          this.initializeData()
          break;
        }
        case "initializeOrderKidsExcel": {
          this.initializeOrderKidsExcel()
          break;
        }
        default:
          break;
      }
    },
    initializeOrderKidsExcel(){
      this.isOpenInitializeOrderKidsExcelDialog = true;
    },
    initializeData() {
      this.isOpenImportData = true;
    },
    closeImportDataRevenueDialog() {
      this.isOpenImportData = false;
      this.getFilterAll()
    },
    closeInitializeOrderKidsExcelDialog() {
      this.isOpenInitializeOrderKidsExcelDialog = false;
      this.getFilterAll()
    },
    getStatusColor(status) {
      if (status === null) {
        return "status-red";
      } else if (status === "Chưa đóng 100%" || status === "Chưa đóng đủ") {
        return "status-orange";
      } else if (status === "Đóng đủ 100%" || status === "Đóng thừa") {
        return "status-blue";
      } else {
        return "";
      }
    },

    getStatusValue(status) {
      return status !== null ? status : "Chưa có hóa đơn";
    },

    tableHeaderColor(column) {
      if (9 < column.columnIndex) {
        return "background-color: #ea580cb3;color: #fff;font-weight: light;"
      }
      return "background-color: #78a5e7;color: #fff;font-weight: light;";
    },
    handleSelectionChange(val) {
      this.multipleSelection = val; // val laf 1 array object
    },

    async getFilterAll() {
      await revenueManagementService.getFilterAll(
          this.dataSearch.month,
          this.dataSearch.kidStatus,
          this.dataSearch.idGrade,
          this.dataSearch.idClass,
          this.dataSearch.name,
          this.dataSearch.collectionTurn,
          this.dataSearch.createdYear,
          this.dataSearch.page,
          this.dataSearch.limit
      ).then((resp) => {
        this.responseFilterList = resp.data.data.filterRevenueDTOS
        this.total = resp.data.data.total
        this.listKT = resp.data.data.listNameKT
        this.listIdRevenueManagement = resp.data.data.listIdRevenueManagement
        this.listIdKids = resp.data.data.listIdKids
        this.listIdOrder = []
        this.listKidCode = []
        for (let i = 0; i < this.responseFilterList.length; i++) {
          if (this.responseFilterList[i].status !== null) {
            this.listIdOrder.push(this.responseFilterList[i].id)
            this.listKidCode.push(this.responseFilterList[i].kidCode)
          }
        }
      }).catch((err) => {
        console.log(err);
        NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu");
      });
    },

    /**
     * Mở dialog hiển thị chi tiết khoản thu
     */
    getDetailKT(row, nameKt) {
      if (row.onlinePaymentSuccessful === true) {
        NotifyMessage.leftCornerNotificationWarning("Hóa đơn đã được thanh toán trực tuyến thành công lên không thể sửa đổi!")
      } else {
        this.detailKT = true;
        this.idOrder = row.id;
        this.$refs.DetailKTRevenueDialog.showDetailKT(
            row.orderKidCode,
            this.dataSearch.collectionTurn,
            nameKt,
            "CLASS",
            this.dataSearch.createdYear
        );
      }
    },

    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "Tổng cộng";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0).toLocaleString("vi-VN", {
            style: "currency",
            currency: "VND"
          });
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    closeDetailKTRevenueDialog(){
      this.detailKT = false;
      this.getFilterAll()
    },

    /**
     * Mở dialog hiển thị tiền đã thu
     */
    collectedMoneyMethod(row) {
      this.showCollectedMoney = true;
      this.idOrder = row.id;
      this.$refs.CollectedMoneyRevenueDialog.getCollectedMoney(this.idOrder);
    },

    closeCollectedMoneyRevenueDialog() {
      this.showCollectedMoney = false;
      this.getFilterAll()
    },


  },
};
</script>
<style lang="scss" scoped>

.search-table {
  margin-bottom: 20px;
  z-index: 1;
  display: flex;
  width: 100%;
  gap: 0.3rem;
  flex-wrap: wrap;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 36px;
  line-height: 35px;
  border-bottom: 0 solid transparent;
  color: #909399;
  background-color: #67c23a !important;
  border-radius: 4px;
  width: 109%;
}

/deep/ .el-submenu__title {
  font-family: Roboto, serif;
  font-size: 14px;
  color: #303133;
  padding: 0 20px;
  -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
}

/deep/ .el-submenu__title i {
  color: #fff;
}

/deep/ .el-menu--popup-right-start {
  margin-left: 5px;
  margin-right: 5px;
}

/deep/ .el-menu--horizontal {
  border-right: none;
}

/deep/ .el-menu--horizontal {
  width: auto;
  border-right: none;
  border-radius: 4px;
}

.loading_title {
  font-family: Roboto, serif;
  font-size: 14px;
  color: red;
  margin-left: auto;
  margin-right: 1.5rem;
}

/deep/ .el-loading-spinner .circular {
  height: 33px;
  width: 42px;
  -webkit-animation: loading-rotate 2s linear infinite;
  animation: loading-rotate 2s linear infinite;
}

.custom_button {
  font-family: Roboto, serif;
  font-size: 14px;
  margin-left: auto;
  margin-right: 0.5rem;
}

.menu-main {
  min-height: 950px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 210px;
  min-height: 700px;
  font-family: Arial, serif;
}

.router-link {
  text-decoration: none;
}

//.el-menu-item {
//  background-color: #1f2d3d !important;
//}

//.el-menu-item:hover {
//  background-color: #49575f !important;
//}

/deep/ .el-message-box {
  display: inline-block;
  vertical-align: top !important;
  width: 420px;
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/deep/ .el-message-box__wrapper::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: top !important;
}

.el-menu {
  margin-bottom: 20px;
}

.onekids-title {
  font-weight: bold;
}

/* Định nghĩa các lớp màu sắc */
.status-red {
  color: red;
}

.status-orange {
  color: orange;
}

.status-blue {
  color: blue;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 2px 0;
}

/deep/ .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #FFF;
}

span.el-tooltip {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

/deep/ .el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #F5F7FA;
  color: #0957f4;
}

/deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #F5F7FA;
  color: #0957f4;
}
</style>